<template>
  <div id="checkCard">
    <navbar />
    <div class="checkCard">
      <div class="content">
        <!-- 到期客户明细查询条件 -->
        <div class="contentHeader">
          <el-row :gutter="10" style="font-weight:400;color:rgba(51,51,51,1);">
            <el-col :span="6">
              机构
              <el-cascader
                id='cascader-multi'
                ref="cascader1"
                v-model="mechanism"
                placeholder="请选择机构名称"
                :options="mechanismOptions"
                :props="{ checkStrictly: true }"
                clearable>
              </el-cascader>
            </el-col>
            <el-col :span="8">
              销售人员业务编码
              <el-input v-model="agentCode" placeholder="请输入业务编码" style="width:50%"></el-input>
            </el-col>
            <el-col :span="10">
              客户证件到期日
              <el-date-picker v-model="cusTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="font-weight:400;color:rgba(51,51,51,1);">
            <el-col :span="6">
              客户姓名
              <el-input v-model="custName" placeholder="请输入客户姓名" ></el-input>
            </el-col>
            <el-col :span="8">
              客户证件号
              <el-input v-model="idNo" placeholder="请输入客户证件号"></el-input>
            </el-col>
            <el-col :span="10">
              证件更新时间
              <el-date-picker v-model="cardTime" style="width:74%" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              是否更新
              <el-select placeholder="请选择" v-model="isFinish">
                  <el-option label="全部" value="">全部</el-option>
                  <el-option label="是" :value="'1'">是</el-option>
                  <el-option label="否" :value="'0'">否</el-option>
              </el-select>
            </el-col>
            <el-col :span="18"></el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-button class="btnFront" @click="reset">重置</el-button>
                </el-col>
                <el-col :span="8">
                  <el-button class="btnFront" @click="search">查询</el-button>
                </el-col>
                <el-col :span="8">
                  <el-button class="btnBack" @click="exportTo">导出</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="contentBody">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="tableHeaderColor" :cell-style="tableCellStyle" >
            <el-table-column type="index" label="序号" fixed width="50"></el-table-column>
            <el-table-column label="客户姓名">
              <template slot-scope="scope">
                <span style="color:skyblue;cursor:pointer;" @click="goSelfInfo(scope.row)">{{ scope.row.custName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="idType" label="客户证件类型" width="160"></el-table-column>
            <el-table-column prop="idNo" label="客户证件号码" width="220"></el-table-column>
            <el-table-column label="客户证件有效期（起期）" >
              <template slot-scope="scope">
                <span v-if="scope.row.cardStartDate.length >= 8">{{scope.row.cardStartDate.slice(0,4)+'-'+scope.row.cardStartDate.slice(4,6)+'-'+scope.row.cardStartDate.slice(6,)}}</span>
                <span v-else> —— </span>
              </template>
            </el-table-column>
            <el-table-column label="客户证件有效期（止期）">
              <template slot-scope="scope">
                <span v-if="scope.row.cardEndDate.length >= 8">{{scope.row.cardEndDate.slice(0,4)+'-'+scope.row.cardEndDate.slice(4,6)+'-'+scope.row.cardEndDate.slice(6,)}}</span>
                <span v-else> —— </span>
              </template>
            </el-table-column>
            <el-table-column prop="mobile" label="客户联系电话" ></el-table-column>
            <el-table-column label="有效期是否更新" >
              <template slot-scope="scope">
                <span>{{scope.row.finishState == '1' ? '是' : '否'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="证件更新时间" >
              <template slot-scope="scope">
                <span v-if="scope.row.finishDate">{{changeDate(scope.row.finishDate)}}</span>
                <span v-else> —— </span>
              </template>
            </el-table-column>
            <el-table-column label="是否联系" prop="shareState"></el-table-column>
            <el-table-column label="联系时间" >
              <template slot-scope="scope">
                <span v-if="scope.row.shareDate">{{changeDate(scope.row.shareDate)}}</span>
                <span v-else> —— </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="contentFooter">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size= "pagesize"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="count">
          </el-pagination>
        </div>
      </div>
      <v-footer></v-footer>
    </div>
  </div>
</template>
<script>
import vFooter from "@/layout/Footer.vue";
import vHeader from '@/layout/Header.vue'
import Navbar from "@/modules/Navbar";
import url from "@/modules/url.js";
import api from "@/modules/api.js";
import { Loading } from "element-ui";
export default {
  name: "checkCard",
  components: {
    vFooter,Navbar
  },
  data() {
    return {
      mechanismOptions: [],
      mechanism: [],
      cusTime: "",
      cardTime: "",
      agentCode: "",
      custName: "",
      idNo: "",
      isFinish: "",
      tableData: [],
      tableHeight: "100%",
      pagesize: 20,
      currentPage: 1,
      count: 0,
      loadingOpt: {
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      },
      status: 3
    };
  },
  mounted() {
    this.getParticipants();
    this.getManagecomLst();
    this.$nextTick(() => {
      this.getTableHeight();
      let searchInfo = window.sessionStorage.getItem('searchInfo')
      console.log("searchInfo",searchInfo)
      if(typeof searchInfo == 'object' && searchInfo != null) {
        searchInfo.mechanism && (this.mechanism = searchInfo.mechanism)
        searchInfo.agentCode && (this.agentCode = searchInfo.agentCode)
        searchInfo.cusTime && (this.cusTime = searchInfo.cusTime)
        searchInfo.isFinish && (this.isFinish = searchInfo.isFinish)
        searchInfo.custName && (this.custName = searchInfo.custName)
        searchInfo.idNo && (this.idNo = searchInfo.idNo)
        searchInfo.currentPage && (this.currentPage = searchInfo.currentPage)
      }
    });
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  },
  methods: {
    getTableHeight() {
      this.tableHeight = (document.querySelector(".contentBody").clientHeight) * 3;
    },
    getParticipants(a,str) {
      this.tableData = []
      this.count = 0
      let t2Code = ''
      let t3Code = ''
      let t4Code = ''
      let curNode = this.$refs['cascader1'].getCheckedNodes()[0]
      console.log("curNode",curNode)
      if(str != 'reset') {
        if(!!curNode && curNode.data.level == '4') {
          t4Code = curNode.data.value
          if(!!curNode.parent && curNode.parent.data.level == '3') {
            t3Code = curNode.parent.data.value
            if(!!curNode.parent.parent && curNode.parent.parent.data.level == '2') {
              t2Code = curNode.parent.parent.data.value
            }
          }
        } else if(!!curNode && curNode.data.level == '3') {
          t3Code = curNode.data.value
          if(!!curNode.parent && curNode.parent.data.level == '2') {
            t2Code = curNode.parent.data.value
          }
        } else if(!!curNode && curNode.data.level == '2') {
          t2Code = curNode.data.value
        }
      }
      let req = {
        t2Code: t2Code,
        t3Code: t3Code,
        t4Code: t4Code,
        agentCode: this.agentCode,
        cardStartDate: this.cusTime != null && this.cusTime[0] ? this.cusTime[0] + ' 00:00:00' : '',
        cardEndDate: this.cusTime != null && this.cusTime[1] ? this.cusTime[1] + ' 23:59:59' : '',
        finishStartDate: this.cardTime != null && this.cardTime[0] ? this.cardTime[0] + ' 00:00:00' : '',
        finishEndDate: this.cardTime != null && this.cardTime[1] ? this.cardTime[1] + ' 23:59:59' : '',
        finishState: this.isFinish,
        custName: this.custName,
        idNo: this.idNo,
        offset: a || this.currentPage,
        limit: 20
      }
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.queryCustomerList, req, (res) => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          this.tableData = res.data.listRepVos;
          this.count = res.data.size;
          this.currentPage = a || 1
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    // 获取机构列表
    getManagecomLst() {
      let loadingInstance = Loading.service(this.loadingOpt);
      let msg = {
        platform: "PC",
        flag: true
      };
      api.post(url.getOrgList, msg, res => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          let children = JSON.stringify(res.data)
            .trim()
            .replace(/"children":\[\],/g, "");
          this.mechanismOptions= JSON.parse(children);
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    search() {
      this.currentPage = 1
      this.getParticipants();
    },
    reset() {
      this.mechanism = this.cusTime = this.cardTime = [];
      this.agentCode = this.isFinish = this.custName = this.idNo = "";
      this.currentPage = 1;
      window.sessionStorage.setItem('searchInfo',{})
      this.getParticipants('','reset')
    },
    exportTo() {
      let t2Code = ''
      let t3Code = ''
      let t4Code = ''
      let curNode = this.$refs['cascader1'].getCheckedNodes()[0]
      if(!!curNode && curNode.data.level == '4') {
        t4Code = curNode.data.value
        if(!!curNode.parent && curNode.parent.data.level == '3') {
          t3Code = curNode.parent.data.value
          if(!!curNode.parent.parent && curNode.parent.parent.data.level == '2') {
            t2Code = curNode.parent.parent.data.value
          }
        }
      } else if(!!curNode && curNode.data.level == '3') {
        t3Code = curNode.data.value
        if(!!curNode.parent && curNode.parent.data.level == '2') {
          t2Code = curNode.parent.data.value
        }
      } else if(!!curNode && curNode.data.level == '2') {
        t2Code = curNode.data.value
      }
      let req = {
        t2Code: t2Code,
        t3Code: t3Code,
        t4Code: t4Code,
        agentCode: this.agentCode,
        cardStartDate: this.cusTime[0] ? this.cusTime[0] + ' 00:00:00' : '',
        cardEndDate: this.cusTime[1] ? this.cusTime[1] + ' 23:59:59' : '',
        finishStartDate: this.cardTime[0] ? this.cardTime[0] + ' 00:00:00' : '',
        finishEndDate: this.cardTime[1] ? this.cardTime[1] + ' 23:59:59' : '',
        finishState: this.isFinish,
        custName: this.custName,
        idNo: this.idNo
      }
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.exportCustomerDetails, req, (res) => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          let saveLink = document.createElement("a");
          saveLink.href = res.data;
          saveLink.download = "客户明细列表";
          saveLink.click();
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "font-weight:bold;color:rgba(211,189,142,1);text-align:center;";
      }
    },
    tableCellStyle({ row, rowIndex }) {
      return "text-align:center;";
    },
    handleCurrentChange(val) {
      this.getParticipants(val);
      document.querySelectorAll(".el-table__body-wrapper")[0].scrollTop = 0;
      document.querySelectorAll(".el-table__body-wrapper")[0].scrollLeft = 0;
    },
    // 进入个人详情页面
    goSelfInfo(arg) {
      console.log("选中的每行数据",arg)
      window.sessionStorage.setItem('consultNo',encodeURIComponent(JSON.stringify(arg.custNo)))
      let obj = {
        mechanism: this.mechanism,
        agentCode: this.agentCode,
        cusTime: this.cusTime,
        cardTime: this.cardTime,
        isFinish: this.isFinish,
        custName: this.custName,
        idNo: this.idNo,
        currentPage: this.currentPage,
      }
      window.sessionStorage.setItem('searchInfo', obj)
      this.$router.push({
        name:'checkCard1Detail',
        params: arg
      })
    },
    changeDate (dateTime) {
      var date = new Date(dateTime)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      var time = year + '-' + month + '-' + day
      return time
    },
  },
};
</script>
<style scoped>
#checkCard {
  font-family: PingFang SC;
  height: 100%;
}
.participant {
  background-color: #f5f6fa;
  padding: 0 25px;
  height: 100%;
}
.content {
  height: calc(100% - 40px);
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(229, 229, 229, 1);
  margin-top: 14px;
}
.contentHeader {
  background: rgba(223, 223, 223, 0);
  border: 1px solid rgba(223, 223, 223, 1);
  margin: 20px 30px 10px;
  padding: 20px 30px;
}
.contentHeader .el-row:last-child {
  padding-bottom: 0px;
}
.el-input__inner {
  height: 35px;
}
.el-input,
.el-select,
.el-date-editor,
.el-cascader {
  width: 70%;
}
.el-row {
  padding-bottom: 20px;
}
.contentHeader .btnFront {
  background: rgba(25, 71, 147, 1);
  color: #fff;
}
.contentBody {
  padding: 0 30px;
  height: calc(100% - 280px);
}
.contentFooter {
  text-align: center;
  margin-top: 10px;
}
.recommender {
  letter-spacing: 5px;
}
.contentHeader .btnBack {
  background: rgba(210, 187, 139, 1);
  color: #fff;
  font-weight: bold;
}
.tipTitle {
  letter-spacing: 5px;
}
#cascader-multi {
  width: 82% !important;
  display: inline-block;
}
.contentBody /deep/ .el-table__cell{
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/checkCard/list1.vue